<template>
  <div>
    <div class="page_title">门店合作审批</div>
    <div class="form_row">
      <div class="form_label">区域:</div>
      <div class="form_value">
        <select class="pullDown" @change="changeProvince" v-model="province">
          <option v-for="(item,index) of provinces" :key="index" :value="item.name">
            {{ item.name }}
          </option>
        </select>
        <select class="pullDown" @change="changeCity" v-model="city">
          <option v-for="(item,index) of citys" :key="index" :value="item.name">
            {{ item.name }}
          </option>
        </select>
        <select class="pullDown" v-model="district">
          <option v-for="(item,index) of districts" :key="index" :value="item">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
    <div class="form_row">
      <div class="form_label">服务类型:</div>
      <select class="form_value radius" v-model="washerType">
        <option v-for="(item,index) of washerTypeList" :key="index" :value="item.id">{{ item.name }}</option>
      </select>
    </div>
    <div class="form_row">
      <div class="form_label">openId:</div>
      <input class="form_value radius" v-model="openId">
    </div>
    <div class="form_row">
      <div class="form_label">状态:</div>
      <select class="form_value radius" v-model="applyState">
        <option v-for="(item,index) of applyStateList" :key="index" :value="item.id">{{ item.name }}</option>
      </select>
    </div>

    <table class="table">
      <thead>
      <tr>
        <td>商家地址</td>
        <td>联系电话</td>
        <td>状态</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item of partnerList" :key="item.openId" @click="goViewPartner(item)">
        <td>{{ item.address }}</td>
        <td>{{ item.phone }}</td>
        <td v-if="item.applyState == -1">驳回</td>
        <td v-if="item.applyState  == 0">审批中</td>
        <td v-else-if="item.applyState == 1">已审批</td>
        <td v-else>未知状态</td>
      </tr>
      </tbody>
    </table>
    <div v-if="loadMore" class="loadMore"><van-loading color="#07c160" size="24"/>加载更多</div>
    <div v-else class="loadMore">已加载所有门店合作申请</div>
  </div>
</template>

<script>
import {getArea} from "../api";
import {getPartnerApplyList} from "../graphql/api";
import { watchScroll } from "../util";
import {log} from "qrcode/lib/core/galois-field";
export default {
  name: "partner_mgr",
  data() {
    return {
      openId: '',     // 申请创建人openId
      currentOpenId: '',
      provinces: [],  //省
      citys: [],      //市
      districts: [],  //区
      currentProvince: null, //当前省份
      province: '不限',
      currentCity: null,     //当前城市
      city: '不限',
      currentDistrict: null, //当前区
      district: '不限',

      washerTypeList: [
        {
          id: [0, 1, 2],
          name: '不限'
        },
        {
          id: [0],
          name: '智能洗车'
        }, {
          id: [1],
          name: '自助洗车'
        }, {
          id: [2],
          name: '人工洗车'
        }
      ],
      washerType: [0, 1, 2],

      applyStateList: [{
        id: [-1, 0, 1],
        name: '不限'
      }, {
        id: [-1],
        name: '驳回'
      }, {
        id: [0],
        name: '审批中'
      },{
        id: [1],
        name: '已审批'
      }],
      applyState: [-1, 0, 1],

      partnerList: [],


      page: 1,
      size: 20,
      loadMore: true
    }
  },
  watch: {
    province: function () {
      this.initVarible()
      if (this.province == "不限") {
        this.currentProvince = null;
      } else {
        this.currentProvince = this.province;
      }
      this.getPartnerList()
    },
    city: function () {
      this.initVarible()
      this.getPartnerList()
    },
    district: function () {
      this.initVarible()
      this.getPartnerList()
    },
    washerType: function () {
      this.initVarible()
      this.getPartnerList()
    },
    applyState: function () {
      this.initVarible()
      this.getPartnerList()
    },
    openId: function () {
      this.initVarible();
      this.getPartnerList();
    },
  },
  mounted() {
    this.queryArea();
    this.getPartnerList();
    this.pagingQuery();
  },
  methods: {
    // 加载更多
    pagingQuery() {
      window.addEventListener('scroll', (e) => {
        watchScroll(e, this.getPartnerList)
      }, true)
    },

    // 初始化参数
    initVarible(){
      this.partnerList = [];
      this.loadMore = true;
    },

    // 请求商家信息列表
    getPartnerList() {
      if (this.openId === "") {
        this.currentOpenId = null
      }else{
        this.currentOpenId = this.openId;
      }
      let params = {
        userAccount: this.currentOpenId,
        province: this.currentProvince,
        city: this.currentCity,
        district: this.currentDistrict,
        washerTypeList: this.washerType,
        applyStateList: this.applyState,
        page: this.page,
        size: 20
      }
      if(this.loadMore){
        getPartnerApplyList(params).then(res => {
          if(!res.data.queryJoinApplyPos){
            this.loadMore = false;
          }else{
            let data =  res.data.queryJoinApplyPos;
            if(data.length < this.size){
              this.loadMore = false;
              console.log('加载终止', this.loadMore);
            }else{
              this.page++;
            }
            for(const item of data){
              this.partnerList.push(item)
            }
          }
          console.log('查询商家信息列表', res);
        }).catch(error => {
          alert(`异常${error}`)
        })
      }else{
        console.log(`查询终止`);
      }
    },

    // 查询全国省市区信息
    queryArea() {
      getArea().then(res => {
        console.log('查询到全国省市区信息', res);
        this.provinces = res.data;
        this.citys = this.provinces[0].city;
        this.districts = this.citys[0].area;
      })
    },

    // 切换省份
    changeProvince() {
      for (const item of this.provinces) {
        if (item.name === this.province) {
          this.citys = item.city;
          this.city = this.citys[0].name
          this.districts = this.citys[0].area;
          this.district = this.districts[0]
        }
      }
    },

    // 切换城市
    changeCity() {
      for (const item of this.citys) {
        if (item.name === this.city) {
          this.districts = item.area;
          console.log('this.districts', this.districts);
          this.district = this.districts[0]
        }
      }
    },

    //   切换服务类型
    changeType() {
      console.log('切换服务类型', this.currentType);
    },

    // 查看商家详情
    goViewPartner(item) {
      this.$router.push({
        name: 'partner_detail',
        params: {
          partner: item
        }
      });
    }

  }
}
</script>

<style src="../css/partner_mgr.css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/pos_approval.vue